import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const usePinPostMutation = createMutationHook(MembershipsCreatorApiClient.pinPost, {
  mutationKey: ['pinPost'],
})
